var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarnessRacing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.597 22.4342C14.6749 22.4342 17.17 19.9391 17.17 16.8612C17.17 13.7833 14.6749 11.2882 11.597 11.2882C8.5191 11.2882 6.02397 13.7833 6.02397 16.8612C6.02397 19.9391 8.5191 22.4342 11.597 22.4342ZM14.9408 16.8613C14.9408 18.7081 13.4437 20.2051 11.597 20.2051C9.75025 20.2051 8.25317 18.7081 8.25317 16.8613C8.25317 16.4715 8.31987 16.0973 8.44248 15.7494L9.74421 16.7257C9.74097 16.7706 9.73932 16.8159 9.73932 16.8616C9.73932 17.8875 10.571 18.7192 11.597 18.7192C12.623 18.7192 13.4547 17.8875 13.4547 16.8616C13.4547 15.8356 12.623 15.0039 11.597 15.0039C11.3901 15.0039 11.1912 15.0377 11.0053 15.1001L10.0445 13.899C10.5084 13.6554 11.0366 13.5175 11.597 13.5175C13.4437 13.5175 14.9408 15.0146 14.9408 16.8613Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61867 8.13013H20.0804C20.2411 8.13013 20.3982 8.18221 20.51 8.2977C20.9007 8.70109 21.7734 9.8574 21.6284 12.0312C21.4427 14.8178 16.7985 16.6754 16.7985 16.6754L14.3835 12.5886L16.716 11.2382C17.0447 11.0478 16.9097 10.5451 16.5298 10.5451H7.05015C6.70265 10.5451 6.54534 10.9796 6.81229 11.2021L8.25316 12.4028L6.76702 14.4462L2.25072 10.451C2.05601 10.2788 1.96547 10.0173 2.01197 9.76156L2.25313 8.4352C2.28525 8.25854 2.43911 8.13013 2.61867 8.13013Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.60075C22 6.0371 20.8356 7.2015 19.3993 7.2015C17.9629 7.2015 16.7985 6.0371 16.7985 4.60075C16.7985 3.16439 17.9629 2 19.3993 2C20.8356 2 22 3.16439 22 4.60075Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarnessRacing);
export default ForwardRef;